/* eslint-disable */
const numsGenerator = (start, end) => {
  let nums = [];
  for (let i = start; i <= end; i++) {
    if (i < 10) {
      nums.push(`0${i}`);
    } else {
      nums.push(`${i}`);
    }
  }
  return nums;
};

export default numsGenerator;
